/* tutor-1 (C): LA TARJETA DEL TOPE, en el lugar del cuadro cuando `usados >= tope`. Gratis: "Llegaste a tus 5
   mensajes de hoy" con "Pasar a Pro" (a /upgrade). Invitado: "Llegaste a tus 3 mensajes de hoy" con "Crear cuenta
   gratis" (a /signup) y "Ver Pro" (a /upgrade). Al dia siguiente el cuadro vuelve solo (la pagina recalcula).

   ARCHIVO EN ASCII A PROPOSITO. */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Sparkles } from 'lucide-react';
import { BOTON_VENTANA_PRINCIPAL, BOTON_VENTANA_SECUNDARIO } from '../alumno/Ventana';

export default function TarjetaDelTope({ plan, alIr }) {
  const { t } = useTranslation('study');
  const invitado = plan === 'guest';
  return (
    <div className="shrink-0 pt-2.5" data-testid="tutor-tope" data-plan={invitado ? 'guest' : 'free'}>
      <div className="rounded-[18px] bg-[#141414] border border-[#222222] p-[22px] grid grid-cols-[44px_1fr] gap-4 items-start">
        <span aria-hidden="true" className="w-11 h-11 rounded-[14px] bg-[#241710] border border-[#3A2414] text-[#F7A06A] flex items-center justify-center">
          <Sparkles className="w-5 h-5" />
        </span>
        <div className="min-w-0">
          <h3 className="m-0 font-['Space_Grotesk'] font-semibold text-[18px] tracking-[-.02em] text-[#F4F4F3]">
            {invitado ? t('tutor.cap.guest_title') : t('tutor.cap.free_title')}
          </h3>
          <p className="mt-1.5 mb-0 text-[14px] leading-[1.5] text-[#C8C8C8]">
            {invitado ? t('tutor.cap.guest_body') : t('tutor.cap.free_body')}
          </p>
          {invitado ? null : <p className="mt-1.5 mb-0 text-[12px] text-[#6F6F6F]">{t('tutor.cap.free_small')}</p>}
        </div>
        {/* tutor-2 (B.5): abajo de 768 los botones van a lo ancho de la tarjeta, de 48 y el principal arriba. */}
        <div className="col-span-2 md:col-span-1 md:col-start-2 flex flex-col md:flex-row md:flex-wrap gap-2 -mt-1.5 md:-mt-0.5">
            {invitado ? (
              <>
                <button type="button" className={BOTON_VENTANA_PRINCIPAL} onClick={() => alIr('/signup')} data-testid="tutor-tope-cuenta">
                  {t('tutor.cap.guest_btn')}
                </button>
                <button type="button" className={BOTON_VENTANA_SECUNDARIO} onClick={() => alIr('/upgrade')} data-testid="tutor-tope-pro">
                  {t('tutor.cap.guest_btn2')}
                </button>
              </>
            ) : (
              <button type="button" className={BOTON_VENTANA_PRINCIPAL} onClick={() => alIr('/upgrade')} data-testid="tutor-tope-pro">
                {t('tutor.cap.free_btn')}
              </button>
            )}
        </div>
      </div>
    </div>
  );
}
